import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// assets
import LockOutlined from '@ant-design/icons/LockOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import UnorderedListOutlined from '@ant-design/icons/UnorderedListOutlined';

// ==============================|| HEADER PROFILE - SETTING TAB ||============================== //

export default function SettingTab({ onClose }) {
  const navigate = useNavigate();

  function goTo(path) {
    onClose?.();
    navigate(path);
  }

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      <ListItemButton onClick={() => goTo('/settings/account')}>
        <ListItemIcon>
          <UserOutlined />
        </ListItemIcon>
        <ListItemText primary="계정 설정" />
      </ListItemButton>
      <ListItemButton onClick={() => goTo('/settings/account')}>
        <ListItemIcon>
          <LockOutlined />
        </ListItemIcon>
        <ListItemText primary="비밀번호 변경" />
      </ListItemButton>
      <ListItemButton onClick={() => goTo('/settings/audit-logs')}>
        <ListItemIcon>
          <UnorderedListOutlined />
        </ListItemIcon>
        <ListItemText primary="감사 로그" />
      </ListItemButton>
    </List>
  );
}

SettingTab.propTypes = {
  onClose: PropTypes.func
};
